import Vue from 'vue'
/**
 * 转换前先替换为 IE 可识别的格式
 * @param time
 * @returns {string}
 */
const replaceTime = (time) => {
  return typeof time === 'string' ? time.replace(/-/g, '/') : time
};

/**
 * 静态数据
 */


Vue.prototype.J_options = {
  visitorVisitType: [//选择拜访标签
    {label: '全部', value: 0},
    {label: '面试', value: 1},
    {label: '商业洽谈', value: 2},
    {label: '参观学习', value: 3},
    {label: '企业拜访', value: 4},
    {label: '领导来访', value: 5},
    {label: '其他', value: 6},
  ],
  visitorState: [//选择状态
    {label: '全部', value: 0},
    {label: '未过期', value: 1},
    {label: '已过期', value: 2},
  ],
  problemType: [
    {label: '水电维修', value: 1},
    {label: '卫生保洁', value: 2},
    {label: '设施维修', value: 3},
    {label: '绿化保养', value: 4},
    {label: '其他', value: 5},
  ],
  feedFromType:[
    {label: '手机端', value: 1},
    {label: '企业门户', value: 2},
  ],
  problemState: [
    {label: '未处理', value: 1},
    {label: '已处理', value: 2},
  ],
};

Vue.filter('empty', (val) => {
  switch (val) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      return val;
  }
});

Vue.filter('date', (val) => {
  switch (val) {
    case null:
    case undefined:
    case 0:
    case '':
      return '-';
    default:
      return new Date(replaceTime(val)).format('yyyy-MM-dd')
  }
});

Vue.filter('datetime', (val) => {
  switch (val) {
    case null:
    case undefined:
    case 0:
    case '':
      return '-';
    default:
      return new Date(replaceTime(val)).format('yyyy-MM-dd hh:mm:ss')
  }
});

Vue.filter('feedFromType', (val) => {
  switch (val) {
    case null:
    case undefined:
    case 0:
      return;
    case 1:
      return '手机端';
    case 2:
      return '企业门户';
  }
});
Vue.filter('date2', (val) => {
  switch (val) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      return new Date(replaceTime(val)).format('yyyy/MM/dd')
  }
});
Vue.filter('buildType', (val) => {
  switch (val) {
    case 1:
      return '办公';
    case 2:
      return '商务';
    case 3:
      return '综合';
    default:
      return val;
  }
});

Vue.filter('visitorState', (value) => {
  switch (value) {
    case 0:
      return
    case 1:
      return '未过期';
    case 2:
      return '已过期';
  }
})

Vue.filter('problemType', (value) => {
  switch (value) {
    case 0:
      return
    case 1:
      return '水电维修';
    case 2:
      return '卫生保洁';
    case 3:
      return '设施维修';
    case 4:
      return '绿化保养';
    case 5:
      return '其他';
  }
})

Vue.filter('compactType', (value) => {
  switch (value) {
    case 1:
      return '租赁合同';
    case 2:
      return '物业合同';
    case 3:
      return '车位合同';
    case 4:
      return '公寓租赁合同';
    case 5:
      return '公寓物业合同';
    default:
      return value
  }
})

Vue.filter('visitorVisitType', (value) => {
  switch (value) {
    case 0:
      return
    case 1:
      return '面试';
    case 2:
      return '商业洽谈';
    case 3:
      return '参观学习';
    case 4:
      return '企业拜访';
    case 5:
      return '领导来访';
    case 6:
      return '其他';
  }
})

Vue.filter('billType', (value) => {
  switch (value) {
    case 1:
      return '租赁'
    case 2:
      return '物业';
    case 3:
      return '车位';
    case 4:
      return '租赁押金';
    case 5:
      return '物业押金';
    case 6:
      return '车位押金';
    default:
      return '-'
  }
})
Vue.filter('billTypeNew', (value) => {
  switch (value) {
    case 1:
      return '租赁费'
    case 2:
      return '物业费';
    case 3:
      return '车位费';
    case 4:
      return '租赁押金';
    case 5:
      return '物业押金';
    case 6:
      return '车位押金';
    case 7:
      return '公寓租金';
    case 8:
      return '公寓押金';
    case 9:
      return '公寓物业租金';
    case 10:
      return '公寓物业押金';
    case 11:
      return '租赁自定义账单';
    case 12:
      return '物业自定义账单';
    default:
      return '-'
  }
})

Vue.filter('datetimeType', (val, type) => {//自定义 date、datetime格式显示
  switch (val) {
    case null:
    case 'null':
    case undefined:
    case 'undefined':
    case '':
      return '-';
    default:
      return new Date(replaceTime(val)).format(type)
  }
});

Vue.filter('roundTwo', (value) => {
  switch (value) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      let num = Math.round(value * 100) / 100;
      num = isNaN(num) ? 0 : num;
      return num;
  }
});

Vue.filter('roundThree', (value) => {
  switch (value) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      let num = Math.round(value * 1000) / 1000;
      num = isNaN(num) ? 0 : num;
      return num;
  }
});

Vue.filter('contractType', (value) => {
  switch (value) {
    case 1:
      return '企业租赁'
    case 2:
      return '企业物业';
    case 3:
      return '公寓租赁';
    case 4:
      return '公寓物业';
    default:
      return '-'
  }
})
Vue.filter('billState', (value) => {
  switch (value) {
    case 1:
      return '未收款'
    case 2:
      return '已收款';
    case 3:
      return '逾期';
    case 4:
      return '未缴清';
    default:
      return '-'
  }
})
Vue.filter('billState1', (value) => {
  switch (value) {
    case 1:
      return '未结清'
    case 2:
      return '已结清';
    case 3:
      return '逾期';
    case 4:
      return '未缴清';
    default:
      return '-'
  }
})
Vue.filter('rentState', (value) => {
  switch (value) {
    case 1:
      return '空闲中'
    case 2:
      return '租赁中';
    case 3:
      return '自用';
    default:
      return '-'
  }
})
Vue.filter('fixState', (value) => {
  switch (value) {
    case 1:
      return '毛胚'
    case 2:
      return '简装';
    case 3:
      return '精装';
    default:
      return '-'
  }
})


Vue.filter("noteType", (val) => {
  switch (val) {
    case 1:
      return "普票";
    case 2:
      return "专票";
    case 3:
      return "收据";
  }
});
Vue.filter("noteState", (val) => {
  switch (val) {
    case 1:
      return "审批中";
    case 2:
      return "已通过";
    case 3:
      return "已驳回";
    case 4:
      return "已确认";
  }
});
Vue.filter("vehicleState", (val) => {
  switch (val) {
    case 1:
      return "待审批";
    case 2:
      return "已通过";
    case 3:
      return "已驳回";
  }
});







// WEBPACK FOOTER //
// ./src/config/options.js